import React from 'react';
import FiltersBar from 'components/FiltersBar/FiltersBar';
import ActionButton from 'components/ActionButton/ActionButton';
import PriceFilter from 'components/PriceFilter/PriceFilter';
import SetFilter from 'components/SetFilter/SetFilter';
import GroupBySelector from '../../screens/Main/ViewCardPrintings/components/GroupBySelector';
import QtyControl from 'components/QtyControl/QtyControl';
import { AssetUrls } from 'config/assets';
import './CardPrintingsHeader.css';

interface SetOption {
  code: string;
  name: string;
  count: number;
}

interface CardPrintingsHeaderProps {
  selectedCount: number;
  onAddToWantlist: () => void;
  onPriceChange?: (min: number, max: number) => void;
  onGroupChange?: (value: string) => void;
  onQtyChange?: (value: number) => void;
  minPrice?: number;
  maxPrice?: number;
  isAddingToWantlist?: boolean;
  buttonText?: string;
  headerTitle?: string;
  headerSubtitle?: string;
  defaultQuantity?: number;
  initialFoil?: boolean;
  initialRegular?: boolean;
  initialLanguages?: string[];
  initialConditions?: string[];
  onFiltersChange?: (filters: any) => void;
  // Set filter props
  sets?: SetOption[];
  selectedSet?: string | null;
  onSetChange?: (setCode: string | null) => void;
}

const CardPrintingsHeader: React.FC<CardPrintingsHeaderProps> = ({
  selectedCount,
  onAddToWantlist,
  onPriceChange,
  onGroupChange,
  onQtyChange,
  minPrice,
  maxPrice,
  isAddingToWantlist = false,
  buttonText,
  headerTitle,
  headerSubtitle,
  defaultQuantity,
  initialFoil,
  initialRegular,
  initialLanguages,
  initialConditions,
  onFiltersChange,
  sets,
  selectedSet,
  onSetChange,
}) => {
  return (
    <div className="card-printings-header">
      {/* Top Title Row */}
      <div className="header-top">
        <div className="header-text">
          <h2 className="title">{headerTitle || 'Choose desired versions'}</h2>
          <p className="subtitle">
            {headerSubtitle || "Select versions of this card that you'd like to receive. We've organized all printings into common categories to make it easier to add many versions."}
          </p>
        </div>
        <div className="header-action">
          <QtyControl defaultValue={defaultQuantity || 1} onChange={onQtyChange} />
          <ActionButton 
            onPress={onAddToWantlist}
            isLoading={isAddingToWantlist}
            isDisabled={selectedCount === 0}
          >
            <img
              src={AssetUrls.icons.misc.heart}
              alt="Heart Icon"
              style={{ width: '14px', height: '14px', marginRight: '6px', flexShrink: 0 }}
            />
            {isAddingToWantlist ? (buttonText?.includes('Update') ? 'Updating...' : 'Adding...') : (buttonText || 'Add to Wantlist')}
          </ActionButton>
        </div>
      </div>

      {/* Price + Set + GroupBy + Filters Row */}
      <div className="header-controls">
        <div className="controls-row">
          <PriceFilter
            defaultMin={minPrice}
            defaultMax={maxPrice}
            onChange={onPriceChange}
          />
          <SetFilter
            sets={sets || []}
            selectedSet={selectedSet ?? null}
            onChange={onSetChange}
          />
          <GroupBySelector onChange={onGroupChange} />
        </div>
        <div className="filters-wrapper">
          <FiltersBar 
            onFiltersChange={onFiltersChange || ((filters) => console.log('Filters:', filters))} 
            initialFoil={initialFoil}
            initialRegular={initialRegular}
            initialLanguages={initialLanguages}
            initialConditions={initialConditions}
          />
        </div>
      </div>
    </div>
  );
};

export default CardPrintingsHeader;
